import React, {Component} from "react";
import {Table, Input, Button, Icon, Row, Col, Tooltip, message, Modal, AutoComplete, Select} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import NHTable from '../../common/NHTable';
import {NHConfirm} from '../../common/NHModal';
import NHContainerFrame from '../../common/NHContainerFrame';
import ViewForm from './ViewForm.js';
import css from './index.css';
import AuditForm from './AuditForm';
import AuditModal from './AuditModal';
import NHModal from "../../common/NHModal";
import {getLoginUser, hasAuth} from '../../../utils/NHCore';

const confirm = Modal.confirm;

const baseUrlPath = "/swbl/lstd"; //基础路径

const jfxtBasicUrl = 'api/zhxg-jfxt/';
/**
 * 是否住宿列表
 * @author xuguanglin
 * @date 2018-08-05
 * Version: 1.0
 */
class index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            frameVisibleMap: {
                tableFlag: true,
                addFlag: false,
                updateFlag: false,
                viewFlag: false,
                auditFlag: false,
                dkgzFlag:false,
            },
            autoCompleteData: [],
            columnName: 'XH',
            statu:''
        };
    }

    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name == showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }
    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }
    //审核按钮点击时间
    handleAuditBtnClick = (record) => {
        this.setState({formInitData: record}, () => {
            this.setCurrentPageShow('auditFlag');
        })
    }
    //查看按钮点击事件
    handleViewBtnClick = (record) => {
        this.setState({formInitData: record});
        this.setCurrentPageShow('viewFlag');
        /* let pkid = record.PKID;//TODO 把此处的信息改成自己的
        NHFetch(baseUrlPath + '/' + pkid + '/get', 'GET')
            .then(res => {
                if(res){
                    this.setState({formInitData: res.data});
                    this.setCurrentPageShow('viewFlag');
                }
            }) */
    }
    
    //单行撤销
    handleOneBackoutBtnClick = (record) => {
        let xsidList = [];
        xsidList.push(record.XSID);
        let params ={
            xsidList:xsidList,
            zzbdhjid:record.ZZBDHJID
        }
        NHConfirm("确认撤销该学生是否住宿审核吗？", () => {
        NHFetch('/swbl/xzsfzz/deleteXzsfzzShxx', 'POST', params)
            .then(res => {
                if (res) {
                    message.success("撤销操作成功！");
                    this.refs.nhTable.readTableData();
                }
            })
        })
    }

    //批量撤销
    handleMoreBackoutBtnClick = () => {
        console.log(this.refs.nhTable.state.selectedRows);
        let selectedRows = this.refs.nhTable.state.selectedRows;
        let xsidList = [];
        if (selectedRows && selectedRows.length > 0) {
            selectedRows.map((elem, index) => {
                xsidList.push(elem['XSID'])
            })
        }else{
            message.warning("请勾选需要撤销的数据");
            return ;
        }
        let pkid = selectedRows[0].ZZBDHJID;
        let params ={
            xsidList:xsidList,
            zzbdhjid:pkid
        }
        NHConfirm("确认批量撤销学生是否住宿申请吗？", () => {
        NHFetch('/swbl/xzsfzz/deleteXzsfzzShxx', 'POST', params)
            .then(res => {
                if (res) {
                    message.success("批量撤销操作成功！");
                    this.refs.nhTable.readTableData();
                }
            })
        })
    }

    //审核保存方法
    handleSaveAudit = () => {
        let yhbh = getLoginUser() ? getLoginUser().userId : '';
        this.refs.nhAuditForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            console.log(formData);
            let data = formData;
            let xsidList = [];
            xsidList.push(data.xsidList);
            data['yhbh'] = yhbh;
            data['xsidList'] = xsidList;
            console.log(formData)
            if(data.shzt ==="1"&&data.SFZS ==="1"){
                // 审核通过时，判断该学生是否有宿舍
                NHFetch(`api/zhxg-yxwz/newStudent/queryStuInfo`, 'GET',{xsid:formData.xsidList[0]})
                .then(res =>{
                    if(res.data && res.data.stuSsxx){
                        // message.success("该学生已分配宿舍");
                        this.operateAudit("audit",data);
                    }else{
                        message.warning("该学生未分配宿舍,请分配宿舍后再审核");
                    }
                })
            }else{
                this.operateAudit("audit",data);
            }

        });
    }
    

    operateAudit=(type,data)=>{
        NHFetch('/swbl/xzsfzz/updateXzsfzzShxx', 'POST', data)
        .then(res => {
          if (res.code===200) {
              message.success("是否住宿审核成功！");
              this.setCurrentPageShow('tableFlag');
              this.refs.nhTable.readTableData();
          }else{
              message.error("是否住宿审核失败！");
          }
        })
    }


    handleSearch = () => {
        if (this.state.columnValue) {
            NHFetch(baseUrlPath + '/getYxxsByKey', 'get', {
                columnName: this.state.columnName,
                value: this.state.columnValue
            }).then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        if(data.length===0){
                            this.setState({statu:'该学生不存在或该学生已添加！'},()=>{
                                this.setState({autoCompleteData: data});
                            })
                        }else{
                            this.setState({statu:''},()=>{
                                this.setState({autoCompleteData: data});
                            })
                        }
                    } else {
                        this.setState({autoCompleteData: []});
                    }
                }
            });
        } else {
            this.setState({autoCompleteData: []});
        }
    }
    handleChange = (value) => {
        NHFetch(baseUrlPath + '/getYxxsByUnion', 'get', {columnName: this.state.columnName, value: value}).then(res => {
            if (res) {
                this.setState({formInitData: res.data}, () => {
                    this.refs.nhAddForm.resetFields(['xsid']);
                });
            }
        });
    }
    buildAutoComplete = (autoCompleteData) => autoCompleteData.map((item,key)=> {
        if(key<10){//限制显示10条，，数据过多页面卡顿
          return <AutoComplete.Option key={item.VALUE}>{item.TEXT}</AutoComplete.Option>
        }
    });

    //导出绿色通道信息
    handleOutPcXx =() =>{
        this.refs.nhTable.exportExcel('是否住宿信息');
    }

    // 打开批量审核弹窗
    openAuditNHmodal = () =>{
        let selectedRows = this.refs.nhTable.state.selectedRows;
        if(selectedRows.length > 0){
            this.refs.moreAudit.show();
        }else{
            message.warning("请勾选需要审核的数据！");
        }
    }

    // 批量审核弹窗确定按钮
    handlemoreSaveAudit = () =>{
        let yhbh = getLoginUser() ? getLoginUser().userId : '';
        let selectedRows = this.refs.nhTable.state.selectedRows;
        let pkid = selectedRows[0].ZZBDHJID;
        let xsidList = [];
        if (selectedRows && selectedRows.length > 0) {
            selectedRows.map((elem, index) => {
                if(elem['SFZS'] == '0'){
                    xsidList.push(elem['XSID'])
                }
            })
        } else {
            message.warn("抱歉！未获取到学生数据，请刷新后再试。")
        }
        this.sfzsAudit.validateFields((err, formData) => {
            if (err) {
                this.refs.moreAudit.stopLoading();
                return;
            }
            formData['yhbh'] = yhbh;
            formData['xsidList'] = xsidList;
            formData['zzbdhjid'] = pkid;
            console.log('数据',formData);
            NHFetch('/swbl/xzsfzz/updateXzsfzzShxx', 'POST', formData)
            .then(res => {
                if (res.code===200) {
                    message.success("批量审核成功！");
                    this.refs.moreAudit.close();
                    this.refs.nhTable.readTableData();
                }else{
                    this.refs.moreAudit.stopLoading();
                    message.error("批量审核失败！");
                }
            })

        })
    }

    render() {
        //列参数
        const columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '60px',
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                searchType:"input"
            }, {
                title: '身份证号',
                dataIndex: 'SFZJH',
                width: '160px',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '100px',
                searchType:"input"
            }, {
                title: '性别',
                dataIndex: 'XBMMC',
                width: '70px',
                searchType:"select"
            }, {
                title: '学院',
                dataIndex: 'BMMC',
                width: '150px',
                searchType:"select"
            }, {
                title: '专业',
                dataIndex: 'ZYMC',
                width: '100px',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级',
                dataIndex: 'BJMC',
                width: '100px',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '是否住宿',
                dataIndex: 'SFZSMC',
                width: '100px',
                searchType:"select"
            }, {
                title: '是否已分配宿舍',
                dataIndex: 'SFFPSS',
                width: '100px',
                searchType:"select"
            }, {
                title: '潜江详细地址',
                dataIndex: 'WSDZ',
                width: '200px',
                searchType:"input"
            }, {
                title: '监护人',
                dataIndex: 'JHR',
                width: '100px',
                searchType:"select"
            }, {
                title: '与监护人关系',
                dataIndex: 'JHRGXMC',
                width: '150px',
                searchType:"input"
            }, {
                title: '监护人电话',
                dataIndex: 'JHRDH',
                width: '100px',
                searchType:"select"
            }, {
                title: '审核状态',
                dataIndex: 'SHZTMC',
                width: '100px',
                fixed: 'right',
                searchType:"select"
            }
        ];
        //行内操作
        const action = [
            {
                title: '审核', onClick: this.handleAuditBtnClick, isShow: (record) => {
                    if (record.SHZT == '0' || record.SHZT=='' || record.SHZT==undefined) {
                        return true;
                    }
                    return false;
                }
                , auth: 'jhyszy_yxgl_swbl_sfzs:review'
            },
            /* {
                title: '撤销', onClick: (record) =>{this.handleOneBackoutBtnClick(record)}, isShow: (record) => {
                    if (record.SHZT == '1') {
                        return true;
                    }
                    return false;
                }
                , auth: 'jhyszy_yxgl_swbl_sfzs:review'
            }, */
            {title: '查看', onClick: this.handleViewBtnClick, auth: 'jhyszy_yxgl_swbl_sfzs:detail'}
        ];
        let autoCompleteData = this.state.autoCompleteData;
        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <div className={css.table} style={{display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none'}}>
                    <NHTable ref='nhTable'
                             rowKey={record => record.XSID}
                             sign={"zhxg_yxxt_xzsfzz"}
                             columns={columns}
                             action={action}
                            //  rangeFilter={true}
                    >
                        {
                            hasAuth('jhyszy_yxgl_swbl_sfzs:review') ?
                                <Button type="primary" ghost style={{marginLeft: 10}}
                                        onClick={this.openAuditNHmodal}>批量审核</Button>
                                : null
                        }
                        {/* {
                            hasAuth('jhyszy_yxgl_swbl_sfzs:delete') ?
                                <Button type="danger" style={{marginLeft: 10}}
                                        onClick={this.handleMoreBackoutBtnClick}>批量撤销</Button>
                                : null
                        } */}
                        {hasAuth('jhyszy_yxgl_swbl_sfzs:export') ?<Button type="primary" onClick={this.handleOutPcXx} style={{ marginLeft: 10 }}>导出</Button>:undefined}
                    </NHTable>
                </div>
                <NHContainerFrame ref="nhShowModal"
                                  visible={this.state.frameVisibleMap.viewFlag}
                                  title="查看住宿信息" //TODO 把此处的信息改成自己的
                                  onCancel={this.handleCloseFrame}
                                  footer={[]}
                >
                    <ViewForm initFormData={this.state.formInitData}/>
                </NHContainerFrame>
                <NHContainerFrame ref="nhAuditModal"
                                  visible={this.state.frameVisibleMap.auditFlag}
                                  title="审核住宿信息" //TODO 把此处的信息改成自己的
                                  onCancel={this.handleCloseFrame}
                                  onOk={this.handleSaveAudit}
                >
                    <AuditForm ref="nhAuditForm" initFormData={this.state.formInitData}/>
                </NHContainerFrame>
                <NHModal ref="moreAudit"
                    title="批量审核"
                    width={620}
                    onOk={this.handlemoreSaveAudit}
                >
                    <AuditModal studentCount={this.state.studentCount} isInit={false} ref={(form) => { this.sfzsAudit = form }} />
                </NHModal>
            </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./components/swbl/sfzs/index.js